<div style="padding: 24px">
    <div class="one-row">
        <span class="spacer"></span>
        <kiene-zeitauswahl [hideAggregate]="true" (change)="zeitintervalChanged($event)"></kiene-zeitauswahl>
        <span class="spacer"></span>
    </div>

    <div class="fk-options">
        <label class="fk-opt">
            <mat-checkbox [formControl]="nurFreigegebenCtrl">Nur freigegebene Belege</mat-checkbox>
            <mat-icon class="fk-info" matTooltip="Nur Kostenbelege, die für die Primanota freigegeben sind. Abgabebelege bleiben unverändert."
                >info</mat-icon
            >
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="leistungsdatumCtrl">Leistungsdatum</mat-checkbox>
            <mat-icon
                class="fk-info"
                matTooltip="Kosten zählen, wenn das Leistungsdatum im Zeitraum liegt, nicht nur das Rechnungsdatum."
                >info</mat-icon
            >
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="mitBefundenCtrl">Mit Befunden</mat-checkbox>
            <mat-icon
                class="fk-info"
                matTooltip="Umsatz und optional Wareneinsatz abgeschlossener Befunde (Status 12) zusätzlich zu den Abgabebelegen (Status 42)."
                >info</mat-icon
            >
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="mitWareneinsatzCtrl">Wareneinsatz in die BWA</mat-checkbox>
            <mat-icon
                class="fk-info"
                matTooltip="Wareneinsatz der Abgabebelege/Befunde in die Gruppe Wareneingang legen. Aus: nur gebuchte 3xxx-Kosten (Einkauf). Beides zusammen zählt Einkauf und Wareneinsatz doppelt."
                >info</mat-icon
            >
        </label>
        <label class="fk-opt">
            <mat-checkbox [formControl]="nullzeilenCtrl">Nullzeilen</mat-checkbox>
            <mat-icon class="fk-info" matTooltip="BWA-Gruppen und Konten ohne Betrag mit anzeigen.">info</mat-icon>
        </label>
    </div>

    <table class="report-ergebnis-table" *ngIf="summen">
        <thead>
            <tr>
                <th></th>
                <th>Umsatz</th>
                <th>Rohertrag</th>
                <th>Betriebsergebnis</th>
                <th>Ergebnis vor Steuern</th>
                <th>Ergebnis</th>
            </tr>
        </thead>
        <tbody>
            <tr style="font-size: 1.6em; font-weight: bold; color: green">
                <td style="font-size: 1em; font-weight: bold; color: gray"></td>
                <td>{{ summen.umsatz | number: "1.2-2" }} &euro;</td>
                <td>
                    {{ summen.rohertrag | number: "1.2-2" }} &euro;<br />
                    <span style="font-size: 0.5em; color: gray">{{ summen.rohertrag_prozent | number: "1.1-1" }} %</span>
                </td>
                <td>
                    {{ summen.betriebsergebnis | number: "1.2-2" }} &euro;<br />
                    <span style="font-size: 0.5em; color: gray"
                        >{{ summen.betriebsergebnis_prozent | number: "1.1-1" }} %</span
                    >
                </td>
                <td>{{ summen.ergebnis_vor_steuern | number: "1.2-2" }} &euro;</td>
                <td>
                    {{ summen.ergebnis | number: "1.2-2" }} &euro;<br />
                    <span style="font-size: 0.5em; color: gray">{{ summen.ergebnis_prozent | number: "1.1-1" }} %</span>
                </td>
            </tr>
        </tbody>
    </table>
    <p class="bwa-hint" *ngIf="summen">
        Umsatzerlöse = Abgabebelege (abgeschlossen)
        <ng-container *ngIf="mitBefundenCtrl.value"> + Befunde</ng-container>
        plus gebuchte Erlöskonten. Wareneingang = gebuchte 3xxx-Kosten
        <ng-container *ngIf="mitWareneinsatzCtrl.value"> plus Wareneinsatz der Verkaufsbelege</ng-container>.
        Wareneinsatz Abgabebelege: {{ summen.wareneinsatz_abgabebelege | number: "1.2-2" }} &euro;
        <ng-container *ngIf="mitBefundenCtrl.value">
            , Befunde: {{ summen.wareneinsatz_befunde | number: "1.2-2" }} &euro;
        </ng-container>
        (siehe auch Report Wareneinsatz).
    </p>

    <div *ngIf="loading" class="one-row" style="margin: 24px 0">
        <span class="spacer"></span>
        <mat-spinner [diameter]="36"></mat-spinner>
        <span class="spacer"></span>
    </div>

    <mat-card>
        <div class="one-row" style="align-items: center">
            <span style="font-weight: 500">BWA</span>
            <span class="spacer"></span>
            <kiene-csv-export
                [columns]="csvColumns"
                [data]="dataSource.data"
                [filename]="csvFilename"
            ></kiene-csv-export>
        </div>
        <table mat-table [dataSource]="dataSource" matSort #bwaSort="matSort">
            <ng-container matColumnDef="bezeichnung">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Position</th>
                <td mat-cell *matCellDef="let e" [class.bwa-indent]="e.seite === 'A' && e.typ === 'gruppe'">
                    {{ e.bezeichnung }}
                </td>
            </ng-container>
            <ng-container matColumnDef="betrag">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Betrag</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.betrag | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="prozent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">% Umsatz</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.prozent | number: "1.1-1" }} %</td>
            </ng-container>
            <ng-container matColumnDef="belege">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Belege</th>
                <td mat-cell *matCellDef="let e" class="number">
                    <ng-container *ngIf="e.typ === 'gruppe'">{{ e.belege | number: "1.0-0" }}</ng-container>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.bwa-summe]="row.typ === 'summe'"
                [class.bwa-ergebnis]="row.key === 'ergebnis' || row.key === 'betriebsergebnis'"
                [class.bwa-selected]="row.typ === 'gruppe' && selectedGruppeId === row.bwa_gruppe_id"
                [class.bwa-click]="row.typ === 'gruppe'"
                (click)="selectGruppe(row)"
            ></tr>
        </table>
        <div *ngIf="!loading && dataSource.data.length === 0" style="padding: 24px; color: #888; text-align: center">
            Keine BWA-Daten im Zeitraum.
        </div>
    </mat-card>

    <mat-card style="margin-top: 24px">
        <div class="one-row" style="align-items: center; gap: 16px; flex-wrap: wrap; padding: 8px 0">
            <span style="font-weight: 500">Nach Konto</span>
            <span class="bwa-hint" *ngIf="selectedGruppeId == null">Klick auf eine BWA-Gruppe filtert diese Liste.</span>
            <span class="bwa-hint" *ngIf="selectedGruppeId != null">
                Filter aktiv –
                <a href (click)="$event.preventDefault(); clearGruppeFilter()">alle Konten</a>
            </span>
            <span class="spacer"></span>
            <kiene-csv-export
                [columns]="csvKontoColumns"
                [data]="kontoDataSource.data"
                [filename]="csvKontoFilename"
            ></kiene-csv-export>
        </div>
        <table mat-table [dataSource]="kontoDataSource" matSort #kontoSort="matSort">
            <ng-container matColumnDef="konto_nr">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Konto</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.konto_nr }}</td>
            </ng-container>
            <ng-container matColumnDef="konto_bezeichnung">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Bezeichnung</th>
                <td mat-cell *matCellDef="let e">{{ e.bezeichnung }}</td>
            </ng-container>
            <ng-container matColumnDef="bwa_gruppe">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>BWA-Gruppe</th>
                <td mat-cell *matCellDef="let e">{{ e.bwa_gruppe }}</td>
            </ng-container>
            <ng-container matColumnDef="quelle">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Quelle</th>
                <td mat-cell *matCellDef="let e">{{ quelleLabel(e.quelle) }}</td>
            </ng-container>
            <ng-container matColumnDef="betrag">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Betrag</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.betrag | number: "1.2-2" }} &euro;</td>
            </ng-container>
            <ng-container matColumnDef="prozent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">% Umsatz</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.prozent | number: "1.1-1" }} %</td>
            </ng-container>
            <ng-container matColumnDef="belege">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="number-header">Belege</th>
                <td mat-cell *matCellDef="let e" class="number">{{ e.belege | number: "1.0-0" }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedKontoColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedKontoColumns"></tr>
        </table>
        <div
            *ngIf="!loading && kontoDataSource.data.length === 0"
            style="padding: 24px; color: #888; text-align: center"
        >
            Keine Konten im Zeitraum.
        </div>
    </mat-card>

    <mat-card style="margin-bottom: 24px; margin-top: 24px; height: 600px" *ngIf="chartHasData">
        <google-chart
            style="width: 100%"
            [type]="chartType"
            [columns]="chartColumns"
            [data]="chartData"
            [height]="600"
            [options]="{ pieHole: 0.4, title: 'Aufwand nach BWA-Gruppe' }"
        >
        </google-chart>
    </mat-card>
</div>
